import BodyTopMenu from '@src/layouts/common/BodyTopMenu';
import DetailLayout from '@src/layouts/detail/DetailLayout';
import MainLayout from '@src/layouts/common/CommonLayout';
import React, { useEffect } from 'react';
import { GetStaticProps } from 'next';
import { t_library } from '@src/types/tables';
import { categoryCode2Id, cvtJson2Library, stripHtmlTags } from '@src/lib/public-lib';
import LibraryService from '@src/services/library/LibraryService';
import Head from "next/head";
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export type DetailProps = {
    data: t_library;
    siteDescription: string;
    libraries: t_library[];
}

export default function Detail(props: DetailProps)
{
    const router = useRouter();

    const meta = {
        title: props.data.title,
        siteDescription: stripHtmlTags(props.data.desc),
        pageUrl: router.asPath,
    };

    return (
        <MainLayout { ...meta }>
            <Head>
                <meta name="description" content={ props.siteDescription } />
            </Head>
            <DetailLayout data={ props.data } libraries={ props.libraries } />
        </MainLayout>
    )
}

export async function getServerSideProps(context: any)
{
    const { id } = context.query;

    const data = await LibraryService.libraryList({
        target: ['*'],
        libraryId: [id as string],
        limit: 0,
        page: 0,
        locale: ''
    });

    if (!data)
        return { notFound: true };

    let genre: string = data[0].LIBRARY_GENRE_CD;
    let genresArray = genre.split(', ');
    let genreCondition = genresArray.map(genre => `LIBRARY_GENRE_CD LIKE '%${genre}%'`).join(" AND ");

    let res = await LibraryService.libraryListCondition({ target: ["*"], cond: `${genreCondition}`, limit: 10, page: 1 });
  
    return {
        props: { 
            data: cvtJson2Library(data[0]),
            libraries: res.map((lib: any) => cvtJson2Library(lib)),
            ...(await serverSideTranslations(context.locale ?? "en", ['common', 'header', "introduce"])),
        },
    };
};